import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const CommuneIndividualEdit = () => {
  const { communeId } = useParams();
  const navigator = useNavigate();
  const [commune, setCommune] = useState({
    fname: "",
    lname: "",
    email: "",
    items: [],
    job_notification_status: "",
    job_notification_type: [],
    number: "",
    primary_role: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  useEffect(() => {
    const getCommune = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/blogs/commune/indi/${communeId}`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        setCommune(data.settings);
      } catch (error) {
        console.log(error);
      }
    };

    getCommune();
  }, [communeId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCommune((prevCommune) => ({
      ...prevCommune,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(
    //   `${process.env.REACT_APP_BACKEND_URL}/blogs/commune/edit/${communeId}`
    // );
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/commune/edit/${communeId}`,
        commune,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      // Redirect to the individual commune page after editing
      navigator(`/communes/${communeId}`);
    } catch (error) {
      console.log(error);
    }
  };

  if (!commune) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Typography variant="h4">Edit Commune</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="First Name"
          name="fname"
          value={commune.fname}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Last Name"
          name="lname"
          value={commune.lname}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Email"
          name="email"
          value={commune.email}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Phone Number"
          name="number"
          value={commune.number}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Primary Role"
          name="primary_role"
          value={commune.primary_role}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Job Notification Type"
          name="job_notification_status"
          value={commune.job_notification_status}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Job Subscription"
          name="job_notification_type"
          value={commune.job_notification_type}
          onChange={handleChange}
        />
        {/* Add more form fields based on your commune schema */}
        <Button type="submit" variant="contained" color="primary">
          Save Changes
        </Button>
      </form>
    </div>
  );
};
